// extracted by mini-css-extract-plugin
export var arrows = "_2o-5";
export var decrementer = "_2o-9";
export var disabled = "_2o-3";
export var error = "_2o-1";
export var hiddenText = "_2o-a";
export var incrementer = "_2o-8";
export var input = "_2o-7";
export var inputWrapper = "_2o-0";
export var leadingIcon = "_2o-b";
export var readonly = "_2o-2";
export var regular = "_2o-6";
export var small = "_2o-4";